import api from '../../utils/api'

import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormSizeGrid from './Form/FormSizeGrid'

function NewSizeGrid({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()
    const navigate = useNavigate()

    

    async function registerSizeGrid(sizeGrid) {
        let msgType = 'success'
        console.log("sizegrid")
        console.log(sizeGrid)
        const data = await api.post('/sizeGrid/new', sizeGrid, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormSizeGrid title="Cadastrar Grade" handleSubmit={registerSizeGrid} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewSizeGrid